module.exports = __webpack_public_path__ + "media/src/img/telegram-icon-blue-09e0c8e0941f333f725cc52ff84210ad.svg";